import { colors, Container, Grid, Paper, TextField, Typography } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useStylesLbl, useStylesTF } from "../../../St/Reports/UseStyle";
import { useStylesAccs } from "./CheckBoxComponents";
import { useTranslation } from "react-i18next";

export default function UsersPermForm(props) {
    const { AutoOptions, gData, changeUserAutos } = props;
    const classes = useStylesAccs();
    const claslbl = useStylesLbl();
    const clasTF = useStylesTF();
    const { t } = useTranslation(["forms", "translation"]);
    return (
        <Container
            style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                listStyle: "none",
                padding: "10px",
                margin: "0px",
                backgroundColor: colors.grey[50],
            }}
            component={Paper}
        >
            {gData.id == 1 ? (
                        <Grid item lg={9} md={8} sm={7} xs={6}>
                    <Typography className={classes.heading2}>{t("translation:sales-settings")}</Typography>

                </Grid>
            ) : gData.id == 2 ? (
                <Grid item lg={9} md={8} sm={7} xs={6}>
                    <Typography className={classes.heading2}>{t("pos-screen-settings")}</Typography>

                </Grid>
            ) :
                gData.id == 3 ? (
                    <Grid item lg={9} md={8} sm={7} xs={6}>
                        <Typography className={classes.heading2}>{t("purchases-settings")}</Typography>

                    </Grid>
                ) : gData.id == 4 ? (
                    <Grid item lg={9} md={8} sm={7} xs={6}>
                        <Typography className={classes.heading2}>{t("translation:basic-data-settings")}</Typography>

                    </Grid>) : gData.id == 5 ? (
                        <Grid item lg={9} md={8} sm={7} xs={6}>
                            <Typography className={classes.heading2}>{t("quotation-settings")}</Typography>

                        </Grid>) : gData.id == 6 ? (
                        <Grid item lg={9} md={8} sm={7} xs={6}>
                                <Typography className={classes.heading2}>{t("purchase-order-settings")}</Typography>

                            </Grid>) :
                    (
                        <Grid item lg={9} md={8} sm={7} xs={6}>
                            <Typography className={classes.heading2}>{t("translation:stock-settings")}</Typography>

                        </Grid>)}
            <Grid item lg={3} md={4} sm={5} xs={6}>
                <Autocomplete
                    classes={clasTF}
                    InputProps={{ className: claslbl.clrBlackTxt }}
                    value={gData.user}
                    onChange={(event, newValue) => {
                        changeUserAutos("branch", newValue);

                    }}
                    id="combo-box-demo"
                    size="small"
                    options={AutoOptions?.Users}
                    getOptionLabel={(option) =>
                        typeof option === "string" ? option : option?.username
                    }
                    style={{}}
                    disableClearable
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={t("user")}
                            variant="outlined"
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}

                        />
                    )}
                />
            </Grid>
        </Container>
    );
}
